import React from 'react';

const Toast = ({ type, message }) => {
  return (
    <div className={`exclusive-toast ${type}`} role="status">
      {message}
    </div>
  );
};

export default Toast;
